var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ActionBase',_vm._g(_vm._b({class:_vm.classNames},'ActionBase',_vm.$attrs,false),_vm.$listeners),[_c('Typography',{attrs:{"variant":"body2Bold"}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }